import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import { store } from '../../store';
import {
  errorCodeSelector,
  coursesSelector,
  courseSelector,
  optionsSelector,
  selectedSelector,
  studentsSelector,
  categoriesSelector,
  modulesSelector,
  modulesStatusSelector,
  classCommentsSelector,
  classCommentCountSelector,
  viewedSelector,
  ratingSelector,
  ratingsSelector,
  childCoursesSelector,
  moduleSelector,
  calculatorOptionsSelector,
  positionCalculatorValuesSelector,
  noMoreSelector,
  pageSelector,
  totalSelector,
  forumSubjectsSelector,
  forumSubjectSelector,
  forumCommentsSelector,
  forumCommentCountSelector,
  forumStudentsSelector,
  readForumSubjectsSelector,
  calendarEventsSelector,
  currentClassIdSelector,
  expandedModulesSelector,
  reportSelector,
  reportsSelector,
  alliancesSelector,
} from './store/selector';
import { coursesApiService } from './services/api';
import { LiquidAssetsSnapshot, CreateLiquidAssetsPayload } from './interfaces/liquid-assets.interface';
import { getRequestErrorCode } from '../../utils/utils';
import { RealEstateSnapshot, CreateRealEstatePayload } from '../../interfaces/real-estate.interface';
import { CreateDiagnosticTradingMetrics, DiagnosticTradingMetrics, TradingMetricsCalculation } from './interfaces/trading-metrics';
import {
  deleteCourseFailuireApiAction,
  deleteCourseInitApiAction,
  deleteCourseSuccessApiAction,
  deleteStudentFailuireApiAction,
  deleteStudentInitApiAction,
  deleteStudentSuccessApiAction,
  getStudentsFailureApiAction,
  getStudentsInitApiAction,
  getStudentsSuccessApiAction,
  getCourseFailureApiAction,
  getCourseInitApiAction,
  getCourseSuccessApiAction,
  getCoursesFailureApiAction,
  getCoursesInitApiAction,
  getCoursesSuccessApiAction,
  postCourseFailuireApiAction,
  postCourseInitApiAction,
  postCourseSuccessApiAction,
  postStudentFailuireApiAction,
  postStudentInitApiAction,
  postStudentSuccessApiAction,
  courseClearAction,
  putCourseFailuireApiAction,
  putCourseInitApiAction,
  putCourseSuccessApiAction,
  resetOptionsAction,
  setCourseAction,
  setOptionsAction,
  getCategoriesInitApiAction,
  getCategoriesSuccessApiAction,
  getCategoriesFailureApiAction,
  postCategoryInitApiAction,
  postCategorySuccessApiAction,
  postCategoryFailuireApiAction,
  putCategoryInitApiAction,
  putCategorySuccessApiAction,
  putCategoryFailuireApiAction,
  deleteCategoryInitApiAction,
  deleteCategorySuccessApiAction,
  deleteCategoryFailuireApiAction,
  getModulesInitApiAction,
  getModulesSuccessApiAction,
  getModulesFailureApiAction,
  addClassToModuleAction,
  removeClassFromModuleAction,
  postModuleInitApiAction,
  postModuleSuccessApiAction,
  postModuleFailuireApiAction,
  postClassInitApiAction,
  postClassSuccessApiAction,
  postClassFailuireApiAction,
  deleteClassInitApiAction,
  deleteClassSuccessApiAction,
  deleteClassFailuireApiAction,
  postClassCommentInitApiAction,
  postClassCommentSuccessApiAction,
  postClassCommentFailuireApiAction,
  getClassCommentsInitApiAction,
  getClassCommentsSuccessApiAction,
  getClassCommentsFailureApiAction,
  deleteViewInitApiAction,
  deleteViewSuccessApiAction,
  deleteViewFailuireApiAction,
  postViewInitApiAction,
  postViewSuccessApiAction,
  postViewFailuireApiAction,
  getViewsInitApiAction,
  getViewsSuccessApiAction,
  getViewsFailuireApiAction,
  putModuleOrderInitApiAction,
  putModuleOrderSuccessApiAction,
  putModuleOrderFailuireApiAction,
  putClassOrderInitApiAction,
  putClassOrderSuccessApiAction,
  putClassOrderFailuireApiAction,
  postRatingInitApiAction,
  postRatingSuccessApiAction,
  postRatingFailuireApiAction,
  getRatingSuccessApiAction,
  getRatingFailureApiAction,
  getRatingInitApiAction,
  getRatingsInitApiAction,
  getRatingsFailureApiAction,
  getRatingsSuccessApiAction,
  getChildCoursesInitApiAction,
  getChildCoursesSuccessApiAction,
  getChildCoursesFailureApiAction,
  postChildCourseInitApiAction,
  postChildCourseSuccessApiAction,
  postChildCourseFailuireApiAction,
  deleteChildCourseInitApiAction,
  deleteChildCourseSuccessApiAction,
  deleteChildCourseFailuireApiAction,
  deleteModulesInitApiActions,
  deleteModulesSuccessApiActions,
  deleteModulesFailureApiActions,
  putModuleInitApiAction,
  putModuleSuccessApiAction,
  setModuleAction,
  deleteClassCommentInitApiAction,
  deleteClassCommentSuccessApiAction,
  deleteClassCommentFailuireApiAction,
  getStudentsFileInitApiAction,
  getStudentsFileFailureApiAction,
  getStudentsFileSuccessApiAction,
  postCalculatorValuesInitApiAction,
  postCalculatorValuesSuccessApiAction,
  postCalculatorValuesFailuireApiAction,
  getPositionCalculatorValuesInitApiAction,
  getPositionCalculatorValuesSuccessApiAction,
  getPositionCalculatorValuesFailureApiAction,
  setCalculatorOptionsAction,
  resetCalculatorOptionsAction,
  increasePageAction,
  calculatorClearAction,
  getForumInitApiAction,
  getForumSuccessApiAction,
  getForumFailureApiAction,
  postForumSubjectInitApiAction,
  postForumSubjectSuccessApiAction,
  postForumSubjectFailuireApiAction,
  putForumSubjectInitApiAction,
  putForumSubjectSuccessApiAction,
  deleteForumSubjectFailureApiActions,
  deleteForumSubjectInitApiActions,
  deleteForumSubjectSuccessApiActions,
  setSubjectAction,
  putForumSubjectOrderInitApiAction,
  putForumSubjectOrderSuccessApiAction,
  putForumSubjectOrderFailuireApiAction,
  postForumCommentInitApiAction,
  postForumCommentSuccessApiAction,
  postForumCommentFailuireApiAction,
  deleteForumCommentInitApiAction,
  deleteForumCommentFailuireApiAction,
  deleteForumCommentSuccessApiAction,
  getForumCommentsInitApiAction,
  getForumCommentsSuccessApiAction,
  getForumCommentsFailureApiAction,
  getDownloadFileInitApiAction,
  getDownloadFileSuccessApiAction,
  getDownloadFileFailureApiAction,
  getForumStudentsInitApiAction,
  getForumStudentsSuccessApiAction,
  getForumStudentsFailureApiAction,
  postForumStudentSuccessApiAction,
  postForumStudentInitApiAction,
  postForumStudentFailuireApiAction,
  deleteForumStudentSuccessApiAction,
  deleteForumStudentFailuireApiAction,
  deleteForumStudentInitApiAction,
  getCalendarInitApiAction,
  getCalendarSuccessApiAction,
  getCalendarFailureApiAction,
  postCalendarEventFailuireApiAction,
  postCalendarEventSuccessApiAction,
  postCalendarEventInitApiAction,
  putCalendarEventInitApiAction,
  putCalendarEventSuccessApiAction,
  deleteCalendarEventSuccessApiAction,
  deleteCalendarEventInitApiAction,
  deleteCalendarEventFailuireApiAction,
  setCurrentClassIdAction,
  toggleExpandedModuleAction,
  expandModuleAction,
  getReportsInitApiAction,
  getReportsSuccessApiAction,
  getReportsFailureApiAction,
  getReportInitApiAction,
  getReportFailureApiAction,
  getReportSuccessApiAction,
  postReportInitApiAction,
  postReportSuccessApiAction,
  postReportFailureApiAction,
  deleteReportInitApiAction,
  deleteReportSuccessApiAction,
  deleteReportFailureApiAction,
  postCalendarEmailInitApiAction,
  postCalendarEmailSuccessApiAction,
  postCalendarEmailFailuireApiAction,
  deleteAllianceInitApiAction,
  deleteAllianceSuccessApiAction,
  getAlliancesInitApiAction,
  getAlliancesSuccessApiAction,
  getAlliancesFailureApiAction,
  deleteAllianceFailureApiAction,
} from './store/reducer';
import { PostCoursePayloadRequest } from './interfaces/post-course';
import { GetCoursesParams } from './interfaces/get-courses';
import { PutCoursePayloadRequest } from './interfaces/put-course';
import { PostStudentPayloadRequest } from './interfaces/post-student';
import { Course } from '../../interfaces/course.interface';
import { PostCategoryPayloadRequest } from './interfaces/post-category';
import { PutCategoryPayloadRequest } from './interfaces/put-category';
import { PostModulePayloadRequest } from './interfaces/post-module';
import { PostClassPayloadRequest } from './interfaces/post-class';
import { PostCommentPayloadRequest } from './interfaces/post-comment';
import { PutModuleOrderPayloadRequest } from './interfaces/put-module-order';
import { PutClassOrderPayloadRequest } from './interfaces/put-class-order';
import { PostRatingPayloadRequest } from './interfaces/post-rating';
import { PutModulePayloadRequest } from './interfaces/put-module';
import { Module, ModuleClass } from '../../interfaces/module.interface';
import { PostForumSubjectPayloadRequest } from './interfaces/post-forum-subject';
import { GetCourseResponse } from './interfaces/get-course';
import { GetReportResponse } from './interfaces/get-report';
import { PostCalculatorValuesPayloadRequest } from './interfaces/post-calculator-values';
import { GetCalculatorValuesParams } from './interfaces/get-calculator-values';
import { PutForumSubjectPayloadRequest } from './interfaces/put-forum-subject';
import { ForumSubject } from '../../interfaces/forum.interface';
import { PutForumSubjectOrderPayloadRequest } from './interfaces/put-forum-subject-order';
import { PostForumStudentPayloadRequest } from './interfaces/post-forum-student';
import { PostCalendarEventPayloadRequest } from './interfaces/post-calendar-event';
import { PutCalendarEventPayloadRequest } from './interfaces/put-calendar-event';
import { PostReportPayloadRequest } from './interfaces/post-report';
import { PostAlliancePayloadRequest } from './interfaces/post-alliance';

export function useCourseCore() {
  const courses = useSelector(coursesSelector);
  const course = useSelector(courseSelector);
  const childCourses = useSelector(childCoursesSelector);
  const ratings = useSelector(ratingsSelector);
  const rating = useSelector(ratingSelector);
  const reports = useSelector(reportsSelector);
  const report = useSelector(reportSelector);
  const categories = useSelector(categoriesSelector);
  const selected = useSelector(selectedSelector);
  const options = useSelector(optionsSelector);
  const students = useSelector(studentsSelector);
  const modules = useSelector(modulesSelector);
  const modulesStatus = useSelector(modulesStatusSelector);
  const module = useSelector(moduleSelector);
  const forumSubjects = useSelector(forumSubjectsSelector);
  const readForumSubjects = useSelector(readForumSubjectsSelector);
  const forumSubject = useSelector(forumSubjectSelector);
  const classComments = useSelector(classCommentsSelector);
  const forumStudents = useSelector(forumStudentsSelector);
  const classCommentCount = useSelector(classCommentCountSelector);
  const forumComments = useSelector(forumCommentsSelector);
  const forumCommentCount = useSelector(forumCommentCountSelector);
  const calendarEvents = useSelector(calendarEventsSelector);
  const viewed = useSelector(viewedSelector);
  const total = useSelector(totalSelector);
  const page = useSelector(pageSelector);
  const noMore = useSelector(noMoreSelector);
  const currentClassId = useSelector(currentClassIdSelector);
  const expandedModules = useSelector(expandedModulesSelector);
  const positionCalculatorValues = useSelector(positionCalculatorValuesSelector);
  const calculatorOptions = useSelector(calculatorOptionsSelector);
  const errorCode = useSelector(errorCodeSelector);
  const alliances = useSelector(alliancesSelector);
  const dispatch = useDispatch();

  const getMeCourses = useCallback(
    async (params: GetCoursesParams, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(getCoursesInitApiAction());
        const response = await coursesApiService.getMeCourses(params);
        dispatch(getCoursesSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getCoursesFailureApiAction({ errorCode: getRequestErrorCode(error) })
        );
      }
    },
    [dispatch]
  );

  const getCourses = useCallback(
    async (params: GetCoursesParams,  onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(getCoursesInitApiAction());
        const response = await coursesApiService.getCourses(params);
        dispatch(getCoursesSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getCoursesFailureApiAction({ errorCode: getRequestErrorCode(error) })
        );
      }
    },
    [dispatch]
  );

  const getCourse = useCallback(
    async (id: string, onSuccess?: (arg0: GetCourseResponse) => void, onFailure?: () => void) => {
      try {
        dispatch(getCourseInitApiAction());
        const response = await coursesApiService.getCourse(id);
        dispatch(getCourseSuccessApiAction(response));
        onSuccess?.(response);
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getCourseFailureApiAction({ errorCode: getRequestErrorCode(error) })
        );
      }
    },
    [dispatch]
  );

  const postCourse = useCallback(
    async (
      body: PostCoursePayloadRequest,
      onSuccess?: (id: string) => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postCourseInitApiAction());
        const response = await coursesApiService.postCourse(body);
        dispatch(postCourseSuccessApiAction());
        onSuccess?.(response.id);
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(postCourseFailuireApiAction());
      }
    },
    [dispatch]
  );

  const putCourse = useCallback(
    async (
      id: string,
      body: PutCoursePayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(putCourseInitApiAction());
        await coursesApiService.putCourse(id, body);
        dispatch(putCourseSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(putCourseFailuireApiAction());
      }
    },
    [dispatch]
  );

  const deleteCourse = useCallback(
    async (id: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(deleteCourseInitApiAction());
        await coursesApiService.deleteCourse(id);
        dispatch(deleteCourseSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deleteCourseFailuireApiAction());
      }
    },
    [dispatch]
  );

  const getChildCourses = useCallback(
    async (id: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(getChildCoursesInitApiAction());
        const response = await coursesApiService.getChildCourses(id);
        dispatch(getChildCoursesSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getChildCoursesFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const postChildCourse = useCallback(
    async (
      id: string,
      cid: string,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postChildCourseInitApiAction());
        await coursesApiService.postChildCourse(id, cid);
        dispatch(postChildCourseSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(postChildCourseFailuireApiAction());
      }
    },
    [dispatch]
  );

  const deleteChildCourses = useCallback(
    async (id: string, cid: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(deleteChildCourseInitApiAction());
        await coursesApiService.deleteChildCourse(id, cid);
        dispatch(deleteChildCourseSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deleteChildCourseFailuireApiAction());
      }
    },
    [dispatch]
  );

  const getStudents = useCallback(
    async (id: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(getStudentsInitApiAction());
        const response = await coursesApiService.getStudents(id);
        dispatch(getStudentsSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getStudentsFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const postStudent = useCallback(
    async (
      id: string,
      body: PostStudentPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postStudentInitApiAction());
        await coursesApiService.postStudent(id, body);
        dispatch(postStudentSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(postStudentFailuireApiAction());
      }
    },
    [dispatch]
  );

  const deleteStudent = useCallback(
    async (id: string, uid: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(deleteStudentInitApiAction());
        await coursesApiService.deleteStudent(id, uid);
        dispatch(deleteStudentSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deleteStudentFailuireApiAction());
      }
    },
    [dispatch]
  );

  const getModules = useCallback(
    async (id: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(getModulesInitApiAction());
        const response = await coursesApiService.getModules(id);
        dispatch(getModulesSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getModulesFailureApiAction({ errorCode: getRequestErrorCode(error) })
        );
      }
    },
    [dispatch]
  );

  const putModuleOrder = useCallback(
    async (
      id: string,
      body: PutModuleOrderPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(putModuleOrderInitApiAction(body));
        await coursesApiService.putModuleOrder(id, body);
        dispatch(putModuleOrderSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          putModuleOrderFailuireApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const getClassComments = useCallback(
    async (cid: string, sid: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(getClassCommentsInitApiAction());
        const response = await coursesApiService.getClassComments(cid, sid);
        dispatch(getClassCommentsSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getClassCommentsFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  // El resumen no va al store: lo usa solo la clase abierta (ClassInfo).
  const getClassSummary = useCallback(
    async (cid: string, sid: string, onSuccess?: (summary: string | null) => void, onFailure?: () => void) => {
      try {
        const response = await coursesApiService.getClassSummary(cid, sid);
        onSuccess?.(response.summary);
      } catch (error: any) {
        console.error(error);
        onFailure?.();
      }
    },
    []
  );

  const getForumComments = useCallback(
    async (cid: string, sid: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(getForumCommentsInitApiAction());
        const response = await coursesApiService.getForumComments(cid, sid);
        dispatch(getForumCommentsSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getForumCommentsFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const postModule = useCallback(
    async (
      id: string,
      body: PostModulePayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postModuleInitApiAction());
        await coursesApiService.postModule(id, body);
        dispatch(postModuleSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(postModuleFailuireApiAction());
      }
    },
    [dispatch]
  );

  const putModule = useCallback(
    async (
      id: string,
      mid: string,
      body: PutModulePayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(putModuleInitApiAction());
        await coursesApiService.putModule(id, mid, body);
        dispatch(putModuleSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(putModuleSuccessApiAction());
      }
    },
    [dispatch]
  );

  const deleteModule = useCallback(
    async (id: string, mid: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(deleteModulesInitApiActions());
        await coursesApiService.deleteModule(id, mid);
        dispatch(deleteModulesSuccessApiActions());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deleteModulesFailureApiActions());
      }
    },
    [dispatch]
  );

  const getForum = useCallback(
    async (cid: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(getForumInitApiAction());
        const response = await coursesApiService.getForum(cid);
        dispatch(getForumSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getForumFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const postForumSubject = useCallback(
    async (
      id: string,
      body: PostForumSubjectPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postForumSubjectInitApiAction());
        await coursesApiService.postForumSubject(id, body);
        dispatch(postForumSubjectSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(postForumSubjectFailuireApiAction());
      }
    },
    [dispatch]
  );

  const putForumSubject = useCallback(
    async (
      id: string,
      sid: string,
      body: PutForumSubjectPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(putForumSubjectInitApiAction());
        await coursesApiService.putForumSubject(id, sid, body);
        dispatch(putForumSubjectSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(putForumSubjectSuccessApiAction());
      }
    },
    [dispatch]
  );

  const deleteForumSubject = useCallback(
    async (id: string, sid: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(deleteForumSubjectInitApiActions());
        await coursesApiService.deleteForumSubject(id, sid);
        dispatch(deleteForumSubjectSuccessApiActions());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deleteForumSubjectFailureApiActions());
      }
    },
    [dispatch]
  );

  const putForumSubjectOrder = useCallback(
    async (
      id: string,
      body: PutForumSubjectOrderPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(putForumSubjectOrderInitApiAction(body));
        await coursesApiService.putForumSubjectOrder(id, body);
        dispatch(putForumSubjectOrderSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          putForumSubjectOrderFailuireApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const getForumStudents = useCallback(
    async (cId: string, sId: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(getForumStudentsInitApiAction());
        const response = await coursesApiService.getForumStudents(cId, sId);
        dispatch(getForumStudentsSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getForumStudentsFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const postForumStudent = useCallback(
    async (
      cId: string,
      sId: string,
      body: PostForumStudentPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postForumStudentInitApiAction());
        await coursesApiService.postForumStudent(cId, sId, body);
        dispatch(postForumStudentSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(postForumStudentFailuireApiAction());
      }
    },
    [dispatch]
  );

  const deleteForumStudent = useCallback(
    async (cId: string, sId: string, uid: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(deleteForumStudentInitApiAction());
        await coursesApiService.deleteForumStudent(cId, sId, uid);
        dispatch(deleteForumStudentSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deleteForumStudentFailuireApiAction());
      }
    },
    [dispatch]
  );

  const getCalendar = useCallback(
    async (cid: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(getCalendarInitApiAction());
        const response = await coursesApiService.getCalendar(cid);
        dispatch(getCalendarSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getCalendarFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const postCalendarEvent = useCallback(
    async (
      id: string,
      body: PostCalendarEventPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postCalendarEventInitApiAction());
        await coursesApiService.postCalendarEvent(id, body);
        dispatch(postCalendarEventSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(postCalendarEventFailuireApiAction());
      }
    },
    [dispatch]
  );

  const postCalendarEmail = useCallback(
    async (
      id: string,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postCalendarEmailInitApiAction());
        await coursesApiService.postCalendarEmail(id,);
        dispatch(postCalendarEmailSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(postCalendarEmailFailuireApiAction());
      }
    },
    [dispatch]
  );

  const putCalendarEvent = useCallback(
    async (
      id: string,
      sid: string,
      body: PutCalendarEventPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(putCalendarEventInitApiAction());
        await coursesApiService.putCalendarEvent(id, sid, body);
        dispatch(putCalendarEventSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(putCalendarEventSuccessApiAction());
      }
    },
    [dispatch]
  );

  const deleteCalendarEvent = useCallback(
    async (id: string, sid: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(deleteCalendarEventInitApiAction());
        await coursesApiService.deleteCalendarEvent(id, sid);
        dispatch(deleteCalendarEventSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deleteCalendarEventFailuireApiAction());
      }
    },
    [dispatch]
  );

  const getCategories = useCallback(
    async (onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(getCategoriesInitApiAction());
        const response = await coursesApiService.getCategories();
        dispatch(getCategoriesSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getCategoriesFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const postCategory = useCallback(
    async (
      body: PostCategoryPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postCategoryInitApiAction());
        await coursesApiService.postCategory(body);
        dispatch(postCategorySuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(postCategoryFailuireApiAction());
      }
    },
    [dispatch]
  );

  const putCategory = useCallback(
    async (
      id: string,
      body: PutCategoryPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(putCategoryInitApiAction());
        await coursesApiService.putCategory(id, body);
        dispatch(putCategorySuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(putCategoryFailuireApiAction());
      }
    },
    [dispatch]
  );

  const deleteCategory = useCallback(
    async (id: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(deleteCategoryInitApiAction());
        await coursesApiService.deleteCategory(id);
        dispatch(deleteCategorySuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deleteCategoryFailuireApiAction());
      }
    },
    [dispatch]
  );

  const postClass = useCallback(
    async (
      cid: string,
      mid: string,
      body: PostClassPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postClassInitApiAction());
        await coursesApiService.postClass(cid, mid, body);
        dispatch(postClassSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(postClassFailuireApiAction());
      }
    },
    [dispatch]
  );

  const deleteClass = useCallback(
    async (id: string, uid: string, sui: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(deleteClassInitApiAction());
        dispatch(removeClassFromModuleAction({ moduleId: uid, classId: sui }));
        await coursesApiService.deleteClass(id, uid, sui);
        dispatch(deleteClassSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deleteClassFailuireApiAction());
        getModules(id);
      }
    },
    [dispatch, getModules]
  );

  const putClassOrder = useCallback(
    async (
      id: string,
      body: PutClassOrderPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(putClassOrderInitApiAction({ id, body }));
        await coursesApiService.putClassOrder(id, body);
        dispatch(putClassOrderSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          putClassOrderFailuireApiAction({
            errorCode: error?.response?.status ?? error?.request?.status,
          })
        );
      }
    },
    [dispatch]
  );

  const postClassComment = useCallback(
    async (
      cid: string,
      sid: string,
      body: PostCommentPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postClassCommentInitApiAction());
        const response = await coursesApiService.postClassComment(cid, sid, body);
        const user = store.getState().me.user;
        if (user) {
          dispatch(
            postClassCommentSuccessApiAction({
              id: response.id,
              content: body.content,
              commentId: body.commentId,
              user,
            })
          );
        }
        onSuccess?.();
        window.setTimeout(() => {
          void (async () => {
            try {
              const refreshed = await coursesApiService.getClassComments(cid, sid);
              dispatch(getClassCommentsSuccessApiAction(refreshed));
            } catch (e) {
              console.error(e);
            }
          })();
        }, 600);
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(postClassCommentFailuireApiAction());
      }
    },
    [dispatch]
  );

  const deleteClassComment = useCallback(
    async (
      cid: string,
      sid: string,
      mid: string,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(deleteClassCommentInitApiAction());
        await coursesApiService.deleteClassComment(cid, sid, mid);
        dispatch(deleteClassCommentSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deleteClassCommentFailuireApiAction());
      }
    },
    [dispatch]
  );

  const postForumComment = useCallback(
    async (
      cid: string,
      sid: string,
      body: PostCommentPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postForumCommentInitApiAction());
        await coursesApiService.postForumComment(cid, sid, body);
        dispatch(postForumCommentSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(postForumCommentFailuireApiAction());
      }
    },
    [dispatch]
  );

  const deleteForumComment = useCallback(
    async (
      cid: string,
      sid: string,
      mid: string,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(deleteForumCommentInitApiAction());
        await coursesApiService.deleteForumComment(cid, sid, mid);
        dispatch(deleteForumCommentSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deleteForumCommentFailuireApiAction());
      }
    },
    [dispatch]
  );

  const getViews = useCallback(
    async (id: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(getViewsInitApiAction());
        const response = await coursesApiService.getCourseViews(id);
        dispatch(getViewsSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getViewsFailuireApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const postView = useCallback(
    async (
      cid: string,
      sid: string,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postViewInitApiAction());
        await coursesApiService.postView(cid, sid);
        dispatch(postViewSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(postViewFailuireApiAction());
      }
    },
    [dispatch]
  );

  const deleteView = useCallback(
    async (
      cid: string,
      sid: string,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(deleteViewInitApiAction());
        await coursesApiService.deleteView(cid, sid);
        dispatch(deleteViewSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deleteViewFailuireApiAction());
      }
    },
    [dispatch]
  );

  const getRatings = useCallback(
    async (
      id: string,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(getRatingsInitApiAction());
        const response = await coursesApiService.getRatings(id);
        dispatch(getRatingsSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getRatingsFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const getRating = useCallback(
    async (
      id: string,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(getRatingInitApiAction());
        const response = await coursesApiService.getRating(id);
        dispatch(getRatingSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getRatingFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const postRating = useCallback(
    async (
      id: string,
      body: PostRatingPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postRatingInitApiAction());
        await coursesApiService.postRating(id, body);
        dispatch(postRatingSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(postRatingFailuireApiAction());
      }
    },
    [dispatch]
  );

  const getStudentsFile = useCallback(
    async (id: string, onSuccess?: (arg0: any) => void, onFailure?: () => void) => {
      try {
        dispatch(getStudentsFileInitApiAction());
        const response = await coursesApiService.getStudentsFile(id);
        dispatch(getStudentsFileSuccessApiAction());
        onSuccess?.(response);
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getStudentsFileFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const getDownloadFile = useCallback(
    async (params: GetCalculatorValuesParams, onSuccess?: (arg0: any) => void, onFailure?: () => void) => {
      try {
        dispatch(getDownloadFileInitApiAction());
        const response = await coursesApiService.getDownloadFile(params);
        dispatch(getDownloadFileSuccessApiAction());
        onSuccess?.(response);
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getDownloadFileFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const getCalculatorValues = useCallback(
    async (
      params: GetCalculatorValuesParams,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(getPositionCalculatorValuesInitApiAction());
        const response = await coursesApiService.getCalculatorValues(params);
        dispatch(getPositionCalculatorValuesSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(getPositionCalculatorValuesFailureApiAction({ errorCode: error.request.status }));
      }
    },
    [dispatch]
  );

  const postCalculatorValues = useCallback(
    async (
      id: string,
      body: PostCalculatorValuesPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postCalculatorValuesInitApiAction());
        await coursesApiService.postCalculatorValues(id, body);
        dispatch(postCalculatorValuesSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(postCalculatorValuesFailuireApiAction());
      }
    },
    [dispatch]
  );

  const getReports = useCallback(
    async (
      id: string,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(getReportsInitApiAction());
        const response = await coursesApiService.getReports(id);
        dispatch(getReportsSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(getReportsFailureApiAction({ errorCode: error.request.status }));
      }
    },
    [dispatch]
  );

  const getReport = useCallback(
    async (
      id: string,
      onSuccess?: (response: GetReportResponse) => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(getReportInitApiAction());
        const response = await coursesApiService.getReport(id);
        dispatch(getReportSuccessApiAction(response));
        onSuccess?.(response);
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(getReportFailureApiAction({ errorCode: error.request.status }));
      }
    },
    [dispatch]
  );

  // PDF del último reporte, marcado con el correo del alumno (no pasa por Redux: es un Blob)
  const getReportFile = useCallback(
    async (id: string, onSuccess?: (file: Blob) => void, onFailure?: () => void) => {
      try {
        const response = await coursesApiService.getReportFile(id);
        onSuccess?.(response);
      } catch (error) {
        console.error(error);
        onFailure?.();
      }
    },
    []
  );

  const postReport = useCallback(
    async (
      id: string,
      body: PostReportPayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postReportInitApiAction());
        await coursesApiService.postReport(id, body);
        dispatch(postReportSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(postReportFailureApiAction());
      }
    },
    [dispatch]
  );

  const deleteReport = useCallback(
    async (id: string, rid: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(deleteReportInitApiAction());
        await coursesApiService.deleteReport(id, rid);
        dispatch(deleteReportSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deleteReportFailureApiAction());
      }
    },
    [dispatch]
  );

  const getAlliances = useCallback(
    async (id: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(getAlliancesInitApiAction());
        const response = await coursesApiService.getAlliances(id);
        dispatch(getAlliancesSuccessApiAction(response));
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(
          getAlliancesFailureApiAction({ errorCode: error.request.status })
        );
      }
    },
    [dispatch]
  );

  const deleteAlliance = useCallback(
    async (id: string, aid: string, onSuccess?: () => void, onFailure?: () => void) => {
      try {
        dispatch(deleteAllianceInitApiAction());
        await coursesApiService.deleteAlliance(id, aid);
        dispatch(deleteAllianceSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(deleteAllianceFailureApiAction());
      }
    },
    [dispatch]
  );

  const getTradingMetrics = useCallback(
    async (id: string, onSuccess?: (data: DiagnosticTradingMetrics) => void, onFailure?: () => void) => {
      try {
        const response = await coursesApiService.getTradingMetrics(id);
        onSuccess?.(response);
      } catch (error) {
        console.error(error);
        onFailure?.();
      }
    },
    []
  );

  const postTradingMetrics = useCallback(
    async (id: string, body: CreateDiagnosticTradingMetrics, onSuccess?: (data: DiagnosticTradingMetrics) => void, onFailure?: () => void) => {
      try {
        const response = await coursesApiService.postTradingMetrics(id, body);
        onSuccess?.(response);
      } catch (error) {
        console.error(error);
        onFailure?.();
      }
    },
    []
  );

  const calculateTradingMetrics = useCallback(
    async (id: string, params: CreateDiagnosticTradingMetrics, onSuccess?: (data: TradingMetricsCalculation) => void, onFailure?: () => void) => {
      try {
        const response = await coursesApiService.calculateTradingMetrics(id, params);
        onSuccess?.(response);
      } catch (error) {
        console.error(error);
        onFailure?.();
      }
    },
    []
  );

  const getMyLiquidAssets = useCallback(
    async (courseId: number, onSuccess?: (data: LiquidAssetsSnapshot | null) => void, onFailure?: () => void) => {
      try {
        const response = await coursesApiService.getMyLiquidAssets(courseId);
        onSuccess?.(response);
      } catch (error) {
        console.error(error);
        onFailure?.();
      }
    },
    []
  );

  const upsertMyLiquidAssets = useCallback(
    async (courseId: number, body: CreateLiquidAssetsPayload, onSuccess?: (data: LiquidAssetsSnapshot) => void, onFailure?: () => void) => {
      try {
        const response = await coursesApiService.upsertMyLiquidAssets(courseId, body);
        onSuccess?.(response);
      } catch (error) {
        console.error(error);
        onFailure?.();
      }
    },
    []
  );

  const getAllLiquidAssets = useCallback(
    async (search: string, onSuccess?: (data: LiquidAssetsSnapshot[]) => void, onFailure?: () => void) => {
      try {
        const response = await coursesApiService.getAllLiquidAssets(search);
        onSuccess?.(response);
      } catch (error) {
        console.error(error);
        onFailure?.();
      }
    },
    []
  );

  const downloadLiquidAssets = useCallback(
    async (search: string, onSuccess?: (blob: any) => void, onFailure?: () => void) => {
      try {
        const response = await coursesApiService.downloadLiquidAssets(search);
        onSuccess?.(response);
      } catch (error) {
        console.error(error);
        onFailure?.();
      }
    },
    []
  );

  const getMyRealEstate = useCallback(
    async (courseId: number, onSuccess?: (data: RealEstateSnapshot | null) => void, onFailure?: () => void) => {
      try {
        const response = await coursesApiService.getMyRealEstate(courseId);
        onSuccess?.(response);
      } catch (error) { console.error(error); onFailure?.(); }
    },
    []
  );

  const upsertMyRealEstate = useCallback(
    async (courseId: number, body: CreateRealEstatePayload, onSuccess?: (data: RealEstateSnapshot) => void, onFailure?: () => void) => {
      try {
        const response = await coursesApiService.upsertMyRealEstate(courseId, body);
        onSuccess?.(response);
      } catch (error) { console.error(error); onFailure?.(); }
    },
    []
  );

  const getAllRealEstate = useCallback(
    async (search: string, onSuccess?: (data: RealEstateSnapshot[]) => void, onFailure?: () => void) => {
      try {
        const response = await coursesApiService.getAllRealEstate(search);
        onSuccess?.(response);
      } catch (error) { console.error(error); onFailure?.(); }
    },
    []
  );

  const downloadRealEstate = useCallback(
    async (search: string, onSuccess?: (blob: any) => void, onFailure?: () => void) => {
      try {
        const response = await coursesApiService.downloadRealEstate(search);
        onSuccess?.(response);
      } catch (error) { console.error(error); onFailure?.(); }
    },
    []
  );

  const getUfValue = useCallback(
    async (onSuccess?: (value: number) => void, onFailure?: () => void) => {
      try {
        const response = await coursesApiService.getUfValue();
        onSuccess?.(response);
      } catch (error) { console.error(error); onFailure?.(); }
    },
    []
  );

  const postAlliance = useCallback(
    async (
      id: string,
      body: PostAlliancePayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postReportInitApiAction());
        await coursesApiService.postAlliance(id, body);
        dispatch(postReportSuccessApiAction());
        onSuccess?.();
      } catch (error: any) {
        console.error(error);
        onFailure?.();
        dispatch(postReportFailureApiAction());
      }
    },
    [dispatch]
  );

  const updateAlliance = useCallback(
    async (
      courseId: string,
      allianceId: string,
      body: PostAlliancePayloadRequest,
      onSuccess?: () => void,
      onFailure?: () => void
    ) => {
      try {
        dispatch(postReportInitApiAction());
        await coursesApiService.updateAlliance(courseId, allianceId, body);
        dispatch(postReportSuccessApiAction());
        onSuccess?.();
      } catch (error) {
        console.error(error);
        dispatch(postReportFailureApiAction());
        onFailure?.();
      }
    },
    [dispatch]
  );

  const selectCourse = useCallback((project: Course) => {
    dispatch(setCourseAction(project))
  }, [dispatch]);

  const selectModule = useCallback((module: Module) => {
    dispatch(setModuleAction(module))
  }, [dispatch]);

  const selectForumSubject = useCallback((subject: ForumSubject | null) => {
    dispatch(setSubjectAction(subject))
  }, [dispatch]);

  const setOptions = useCallback((options: GetCoursesParams) => {
    dispatch(setOptionsAction(options))
  }, [dispatch]);

  const clearCalculatorValues = useCallback(() => {
    dispatch(calculatorClearAction());
  }, [dispatch]);

  const increasePage = useCallback(() => {
    dispatch(increasePageAction());
  }, [dispatch]);

  const setCalculatorOptions = useCallback((options: GetCalculatorValuesParams) => {
    dispatch(setCalculatorOptionsAction(options));
  }, [dispatch]);

  const setCurrentClassId = useCallback((currentClass: string) => {
    dispatch(setCurrentClassIdAction(currentClass));
  }, [dispatch]);

  const toggleExpandedModule = useCallback((module: string) => {
    dispatch(toggleExpandedModuleAction(module));
  }, [dispatch]);

  const expandModule = useCallback((module: string) => {
    dispatch(expandModuleAction(module));
  }, [dispatch]);

  const resetOptions = useCallback(() => {
    dispatch(resetOptionsAction());
  }, [dispatch]);

  const resetCalculatorOptions = useCallback(() => {
    dispatch(resetCalculatorOptionsAction());
  }, [dispatch]);

  const clearCourse = useCallback(() => {
    dispatch(courseClearAction());
  }, [dispatch]);

  const addClassToModule = useCallback(
    (moduleId: string, moduleClass: ModuleClass) => {
      dispatch(addClassToModuleAction({ moduleId, moduleClass }));
    },
    [dispatch],
  );

  return {
    courses,
    course,
    childCourses,
    ratings,
    rating,
    reports,
    report,
    categories,
    selected,
    students,
    modules,
    modulesStatus,
    module,
    forumSubjects,
    forumSubject,
    readForumSubjects,
    classComments,
    classCommentCount,
    forumStudents,
    forumComments,
    forumCommentCount,
    calendarEvents,
    currentClassId,
    expandedModules,
    viewed,
    options,
    positionCalculatorValues,
    calculatorOptions,
    page,
    total,
    noMore,
    errorCode,
    alliances,
    getMeCourses,
    getCourses,
    getCourse,
    getStudents,
    getModules,
    addClassToModule,
    getClassComments,
    getClassSummary,
    getForumComments,
    postCourse,
    putCourse,
    deleteCourse,
    postStudent,
    deleteStudent,
    postModule,
    putModule,
    deleteModule,
    getCategories,
    postCategory,
    putCategory,
    deleteCategory,
    postClass,
    deleteClass,
    putClassOrder,
    postClassComment,
    deleteClassComment,
    postForumComment,
    deleteForumComment,
    getViews,
    postView,
    deleteView,
    putModuleOrder,
    getRatings,
    getRating,
    postRating,
    getChildCourses,
    postChildCourse,
    deleteChildCourses,
    getStudentsFile,
    getCalculatorValues,
    postCalculatorValues,
    getReports,
    getReport,
    postReport,
    deleteReport,
    postCalendarEmail,
    setCalculatorOptions,
    resetCalculatorOptions,
    clearCalculatorValues,
    getCalendar,
    postCalendarEvent,
    putCalendarEvent,
    deleteCalendarEvent,
    setCurrentClassId,
    toggleExpandedModule,
    expandModule,
    getForum,
    postForumSubject,
    putForumSubject,
    deleteForumSubject,
    selectForumSubject,
    putForumSubjectOrder,
    getDownloadFile,
    getForumStudents,
    postForumStudent,
    deleteForumStudent,
    increasePage,
    selectCourse,
    selectModule,
    setOptions,
    resetOptions,
    clearCourse,
    getAlliances,
    deleteAlliance,
    postAlliance,
    updateAlliance,
    getTradingMetrics,
    postTradingMetrics,
    calculateTradingMetrics,
    getMyLiquidAssets,
    upsertMyLiquidAssets,
    getAllLiquidAssets,
    downloadLiquidAssets,
    getReportFile,
    getMyRealEstate,
    upsertMyRealEstate,
    getAllRealEstate,
    downloadRealEstate,
    getUfValue
  };
}
